// extracted by mini-css-extract-plugin
module.exports = {"buttonStaff":"styles_buttonStaff__2K7h-","button":"styles_button__2Z3bO","buttonText":"styles_buttonText__tPLs7"};